/**
 * Principals API service: the admin directory, one principal's identity and grants, and their
 * vendor company.
 */

import type { PrincipalDetail, PrincipalListResponse } from "@/generated/sdk"

import { sdk, sdkCall } from "./sdk"

export type { PrincipalDetail, PrincipalGrant, PrincipalSummary } from "@/generated/sdk"

export const principalsApi = {
  listPrincipals: async (
    params: { limit?: number; nextToken?: string } = {},
  ): Promise<PrincipalListResponse> => {
    return sdkCall(sdk.listPrincipals(params))
  },

  getPrincipal: async (principalId: string): Promise<PrincipalDetail> => {
    return sdkCall(sdk.getPrincipal({ principalId }))
  },

  /**
   * Set a principal's vendor company.
   */
  assignCompany: async (principalId: string, companyId: string): Promise<PrincipalDetail> => {
    return sdkCall(
      sdk.updatePrincipal({
        principalId,
        principalUpdateRequest: { company_id: companyId },
      }),
    )
  },
}
